module.exports = __webpack_public_path__ + "img/avatar-icon.9b01227b.png";